<template>
    <div class="rodape">
        <div class="lojas">
            <div class="loja">
                <div class="endereco">
                    <div class="titulo">Loja Centro</div>
                    <div>Rua do Ouvidor, 149</div>
                    <div>Centro - Rio de Janeiro, RJ - CEP: 20040-030 </div>
                    <div>Whatsapp: (21) 99613-9311 Tel: (21) 2507-1422</div>
                </div>
                <div class="horario">
                    <div class="titulo2">Horário de funcionamento</div>
                    <div>Seg à Sex: 9h às 18h Sábados: 9h às 13h</div>
                </div>
            </div>
            <div class="loja">
                <div class="endereco">
                    <div class="titulo">Loja Shopping Polo Textil Rio</div>
                    <div>Av. Paulo de Frontin, 333 loja 137 ou</div>
                    <div>Rua Aristides Lobo, 80 loja 137</div>
                    <div>Rio Comprido - Rio de Janeiro, RJ - CEP: 20250-450 </div>
                    <div>Whatsapp: (21) 99613-9634 Tel: (21) 2137-5232</div>
                </div>
                <div class="horario">
                    <div class="titulo2">Horário de funcionamento</div>
                    <div>Seg à Sex: 9h às 18h Sábados: 9h às 13h</div>
                </div>
            </div>
        </div>
        <div class="redes">
            <div class="endereco">
                <div class="titulo-redes">Siga nossas redes sociais</div>
            </div>
            <div class="icones">
                <div class="icone" @click="whatsapp">
                <mdi-whatsapp class="icon-2x"></mdi-whatsapp>
                </div>
                <div  class="icone" @click="facebook">
                <mdi-facebook class="icon-2x"></mdi-facebook>
                </div>
                <div  class="icone" @click="instagram">
                <mdi-instagram class="icon-2x"></mdi-instagram>
                </div>
            </div>
        </div>
    </div>
    
</template>
<style lang="sass" scoped>
  @import "@/assets/scss/rodape.scss"

</style>
<script>
export default {
    data: function(){
        return{
            
        }
    },
    methods:{
        whatsapp: function(){

          window.open("https://api.whatsapp.com/send/?phone=5521996139520&text=Ol%C3%A1%2C+vim+atrav%C3%A9s+do+Guia+de+Modistas+Assuf&app_absent=0", "_blank");

      },
      facebook: function(){
          window.open("https://www.facebook.com/casa.assuf/", "_blank");

      },
      instagram: function(){
          window.open("https://www.instagram.com/casaassuf/?hl=pt-br", "_blank");

      }

    }
}
</script>